import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../../api";

export function useDeleteUserGroup() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (groupId: string) => api.deleteUserGroup(groupId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["user-groups"] });
    },
  });
}
